import { render } from "./WeightLossContentPtBR.vue?vue&type=template&id=3db897bf&scoped=true"
import script from "./WeightLossContentPtBR.vue?vue&type=script&lang=js"
export * from "./WeightLossContentPtBR.vue?vue&type=script&lang=js"

import "./WeightLossContentPtBR.vue?vue&type=style&index=0&id=3db897bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db897bf"]])

export default __exports__